import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import Contactform from './Contactform';
import './ContactForm.css';
import api from '../api';
import Navbar from './Navbar';
import Footer from './Footer';
import TopBar from './TopBar';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });
  const [loading, setLoading] = useState(false);

  const handleInputChange = (name, value) => {
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const validateForm = () => {
    if (!formData.name.trim()) {
      toast.error('Name is required');
      return false;
    }
    if (!formData.email.trim()) {
      toast.error('Email is required');
      return false;
    }
    const emailRegex = /^\S+@\S+\.\S+$/;
    if (!emailRegex.test(formData.email)) {
      toast.error('Please enter a valid email address');
      return false;
    }
    if (!formData.message.trim()) {
      toast.error('Message is required');
      return false;
    }
    return true;
  };

  const handleSubmit = async e => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setLoading(true);

    try {
      // Send to backend API
      await api.post('/contact/submit', formData);

      toast.success('Thank you for reaching out! We will get back to you soon.');
      setFormData({
        name: '',
        email: '',
        phone: '',
        message: '',
      });
    } catch (err) {
      console.error('Contact form error:', err);
      toast.error(err.response?.data?.message || 'Failed to send message. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="page-contact">
      <TopBar />
      <div className="container">
        <Navbar />
        <section className="page-header">
          <h1>Contact</h1>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb foi-breadcrumb">
              <li className="breadcrumb-item">
                <a href="/">Home</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Contact
              </li>
            </ol>
          </nav>
        </section>
      </div>
      <div className="container1">
        <span className="big-circle"></span>

        <div className="form">
          <div className="contact-info">
            <h3 className="title">Tell us about yourself</h3>
            <p className="text">
              Whether you have questions or you would just like to say hello, contact us.
            </p>

            <div className="info">
              <div className="information">
                <i className="fas fa-map-marker-alt"></i>&nbsp;
                <p>KN4 AVE- CAR FREE ZONE NEXT TO BK HQ</p>
              </div>
              <div className="information">
                <i className="fas fa-envelope"></i>&nbsp;
                <p>info@finexperts.com</p>
              </div>
              <div className="information">
                <i className="fas fa-phone"></i>&nbsp;&nbsp;
                <p>+250788393784</p>
              </div>
            </div>

            <div className="social-media">
              <p>Connect with us :</p>
              <div className="social-icons">
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-twitter"></i>
                </a>
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-instagram"></i>
                </a>
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-linkedin-in"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="contact-form">
            <span className="circle one"></span>
            <span className="circle two"></span>

            <form onSubmit={handleSubmit} autoComplete="off" noValidate>
              <h3 className="title">Contact us</h3>
              <Contactform
                type="text"
                name="name"
                label="Full Name"
                value={formData.name}
                onChange={handleInputChange}
                required
              />
              <Contactform
                type="email"
                name="email"
                label="Email"
                value={formData.email}
                onChange={handleInputChange}
                required
              />
              <Contactform
                type="tel"
                name="phone"
                label="Phone"
                value={formData.phone}
                onChange={handleInputChange}
              />
              <Contactform
                type="textarea"
                name="message"
                label="Message"
                value={formData.message}
                onChange={handleInputChange}
                required
              />
              <button type="submit" className="btn1" disabled={loading}>
                {loading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Sending...
                  </>
                ) : (
                  'Send'
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </main>
  );
};

Contact.propTypes = {};

export default Contact;
